//import { useGrid } from "common";
import { useParams } from "common/components/Form/ParamsContext";
import { getProgramReviewUrlService } from "./programReviewUrlApi";

export default function useProgramReviewUrlList() {
  const params = useParams<"program_id" | "review_partner_id">();
  const scope = {
    programs: params.program_id,
    "review-partners": params.review_partner_id,
  };
  const editUrl = `${
    Object.values(scope || {}).filter(v => !!v).length > 0
      ? "program-review-urls/"
      : ""
  }`;
  const service = getProgramReviewUrlService(scope);

  return { ...service, params, scope, editUrl };
}
